import { Link } from 'react-router-dom';
import MessageImg from '../assets/images/services/connection/message-en.png';
import MessageImgSmall from '../assets/images/services/connection/message-small-en.png';
import DigitalAvatarPhone from '../assets/images/services/phone-avatar-creation-en.png';

export const lang = {
  head: {
    mainPage: {
      title: 'Mykin | Património digital',
      description: 'Património digital. Criar um avatar de antepassado digital | Mykin',
      ogDescription: 'Reencarnação digital | Mykin'
    },
    timeCapsule: {
      title: 'Mykin | Cápsula do tempo',
      description: 'Uma cápsula do tempo multimédia para a sua família e os seus descendentes | Mykin',
      ogDescription: 'Legado familiar. Mantenha viva a memória dos seus entes queridos | Mykin'
    },
    digitalAvatar: {
      title: 'Mykin | Avatar digital',
      description: 'Um avatar de antepassado digital com a capacidade de comunicar com o antepassado | Mykin',
      ogDescription: 'Um avatar de antepassado digital com a capacidade de comunicar com o antepassado | Mykin'
    },
    connection: {
      title: 'Mykin | Connection with your passed-away',
      description: 'Connection with your passed-away | Mykin',
      ogDescription: 'Connection with your passed-away | Mykin'
    },
    shortStory: {
      title: 'Mykin | Grandpa',
      description: 'Grandpa | Mykin',
      ogDescription: 'Grandpa | Mykin'
    },
    privacyPolicy: {
      title: 'Mykin | Política de Privacidade',
      description: 'Política de Privacidade | Mykin',
      ogDescription: 'Política de Privacidade | Mykin'
    },
    termsOfUse: {
      title: 'Mykin | Acordo do utilizador',
      description: 'Acordo do utilizador | Mykin',
      ogDescription: 'Acordo do utilizador | Mykin'
    },
    login: {
      title: 'Mykin | Iniciar sessão na conta',
      description: 'Património digital. Criar um avatar de antepassado digital | Mykin',
      ogDescription: 'Reencarnação digital | Mykin',
    },
    treePage: {
      title: 'Mykin | Árvore',
      description: 'Património digital. Criar um avatar de antepassado digital | Mykin',
      ogDescription: 'Reencarnação digital | Mykin'
    },
    noMatch: {
      title: 'Mykin | Página não encontrada',
      description: 'Património digital. Criar um avatar de antepassado digital | Mykin',
      ogDescription: 'Reencarnação digital | Mykin'
    }
  },
  tree: {
    emptyTree: 'Não foi criada nenhuma árvore de utilizadores',
    updateBrowser: 'Atualizar o seu browser',
    dateOfBirth: 'Data de nascimento',
    placeOfBirth: 'Local de nascimento',
    noPhoto: 'Sem foto',
    gender: 'Gênero',
    female: 'Fêmea',
    male: 'Macho',
    neutral: 'Neutro'
  },
  login: {
    welcome: 'Bem-vindo ao Mykin',
    signFrom: 'ou entre com',
    continueWith: 'Continue com',
    error: 'Este usuário não está cadastrado no sistema Mykin!',
    goBack: 'Voltar',
    enterEmail: 'Digite o e-mail',
    email: 'E-mail',
     enterPassword: 'Digite a senha',
     password: 'Senha',
     loginButton: 'Login',
     errorEmailPassword: 'E-mail ou senha incorreta digitada.',
     errorTryAgain: 'Tente novamente!',
     forgotPassword: 'Esqueceu sua senha?'
  },
  restorePassword: {
    title: 'Recuperação de senha',
    description: 'Para recuperar sua senha, digite seu e-mail em que a conta está registrada',
    placeholder: 'Digite o e-mail',
    button: 'Confirme',
    errorEmail: 'O usuário não foi encontrado',
    linkSend: 'Um link para alterar sua senha foi enviado para o seu endereço de e-mail',
    retryLogin: 'Tentar login novamente'
  },
  header: {
    changeLang: 'Alterar o idioma',
    chooseLang: 'Escolha o seu idioma',
    myProfile: 'Meu perfil',
    login: 'Entrar',
    logout: 'Saída',
    aboutUs: 'Sobre nós',
    services: 'Serviços',
  },
  footer: {
    privacyPolicy: 'Política de Privacidade',
    userAgreement: 'Acordo do utilizador',
  },
  main: {
    title: 'Explore a vida de seus ancestrais',
    slider: [
      'Momentos de comunicação com parentes próximos têm um componente emocional muito forte para uma pessoa. São as emoções que marcam a memória e permanecem para nós um fragmento de um filme de vida',
      'Infelizmente, uma pessoa não pode viver para sempre e pessoas próximas a nós vão para outro mundo. Não significa que o caminho deles pare... Tem um significado muito emocional para nós... É um grande estresse para uma pessoa... A comunicação se torna um monólogo interno...',
      'A imagem de um parente em nossa memória é muito importante e é uma espécie de código pessoal de percepção de uma determinada pessoa. Para uma pessoa, uma imagem de memória é uma construção comportamental.',
      'Nem todo mundo resiste ao tempo... Muitos são esquecidos e não há como reviver seu perfil digital. Todos tiveram uma vida cheia de emoções e acontecimentos.',
      'A equipe MYKIN realizou um estudo no qual descobrimos que: A memória de uma pessoa vive, em média, 100 anos. Depois - cada pessoa vai para o esquecimento PARA SEMPRE! Só resta uma foto (se houver data de vida e morte)...',
      'Propomos transferir imagens da nossa memória de parentes e antepassados ​​para um perfil digital e assim dar-lhes uma nova vida digital!',
      'Com a ajuda do aplicativo móvel MYKIN, poderemos preservar de forma interativa a memória de nossos ancestrais. E a rede neural e a inteligência artificial com base nessas informações poderão "reanimá-los" para comunicação. Nossos descendentes poderão se comunicar com contemporâneos de diferentes épocas de sua espécie!',
      'O perfil digital já faz parte do mundo real e a transição para a imortalidade digital após a morte de uma pessoa é um novo tipo de transformação da vida e o surgimento de um novo tipo de comunicação entre o mundo real e o digital.',
      'Avatar digital. A comunicação não será diferente dos mensageiros habituais. Preencha o roteiro com texto e temas e converse com os ancestrais. Esse tipo de comunicação é uma ferramenta muito importante para aliviar o estresse de uma pessoa após a perda de um parente. Disponível em 2023',
      'Comunicação de voz com imitação da voz de um parente e ancestral. Essa opção parece uma fantasia, mas não é. Para tal comunicação, você precisa carregar um arquivo de áudio com a voz de seu familiar para o aplicativo. Disponível em 2023',
      'Uma cópia holográfica de seu parente ou ancestral. Este tipo de comunicação inclui texto, voz e comunicação visual. Esse tipo de comunicação será possível com a introdução da tecnologia de comunicação 6G no dia a dia. O desenvolvimento está em andamento e até 2030 será parte integrante de nossas vidas.',
      'Ao preencher nosso próprio perfil digital no aplicativo ou o perfil de um ancestral com informações, podemos criar uma cópia digital da consciência ou uma cópia digital da imagem de percepção de uma pessoa. Quanto mais informações, mais "vivo" o perfil digital. Discuta novas descobertas na genealogia familiar. ',
    ],
    watchVideo: 'Assista vídeo',
    downloadDescription:
      'Até 5 de abril de 2025, estamos realizando trabalhos técnicos no aplicativo móvel para preparar a atualização do Mykin para a versão 3.0. Algumas funcionalidades podem apresentar instabilidade durante este período. Pedimos desculpas por quaisquer inconvenientes. Seu guia para o mundo da história e dos laços familiares. Construa sua própria árvore genealógica única descobrindo o passado de sua família e reconstruindo sua árvore genealógica.',
    instructionTitle: 'Instrução',
    instructionItems: [
      'Cadastre-se no aplicativo',
      'Crie seu perfil digital',
      'Comece a construir sua árvore genealógica',
      'Você pode criar um avatar digital para qualquer perfil em sua árvore',
      'A criação de um avatar digital está incluída na assinatura paga',
      'Se inscrever',
      'Vá para a seção "Avatar" e adicione o perfil daquele parente da sua árvore com quem você deseja estabelecer uma comunicação virtual',
      'Clonagem de voz ancestral e mensagens de voz disponíveis para versão em inglês',
      'Quanto mais informações sobre seu ancestral você souber, mais comunicação ao vivo espera por você',
      'Dê uma nova vida à sua árvore genealógica e você verá como sua vida mudará',
    ],
  },
  services: {
    timeCapsule: 'Cápsula do tempo',
    digitalAvatar: 'Avatar digital',
    connection: 'Connection with your passed-away'
  },
  timeCapsule: {
    more: "More details",
    title: 'Faça um presente único para os seus entes queridos',
    description:
      '"CAPSULA OF TIME" é um filme em que tu e a tua família se tornam os heróis e falam de ti, dos teus antepassados e deixam uma mensagem em vídeo aos teus descendentes!',
    steps: [
      'Script',
      'Realização',
      'Trabalho do operador de câmara',
      'Som e luz',
      'Montagem',
    ],
    moreInfo: 'Mais informações no',
    subTitle: 'A cápsula do tempo - guardada para sempre',
    subDescription:
      'No canal do youtube MyKin com acesso aberto ou acesso apenas para a sua família e parentes. Um duplicado da cápsula do tempo é gravado numa pen e entregue a si!',
    priceTitle: 'Quanto é que custa?',
    rub: 'RUB',
    priceDescription:
      'Não está a comprar - está a preservar a história da sua família, e isso não tem preço!',
    orderTitle: 'Encomendar',
    name: 'Seu nome',
    phone: 'Número de telefone',
    send: 'Enviar',
    orderSend: 'A sua encomenda foi enviada com sucesso!'
  },
  digitalAvatar: {
    title: 'O avatar digital como uma nova forma de comunicação',
    description:
      'Trata-se de uma oportunidade única para ultrapassar a visão e a atitude habituais em relação à cessação natural da vida humana devido ao envelhecimento do corpo.',
    aliveTitle: (
      <>
        Podemos trazer uma pessoa de volta à vida? <br />
        É possível criar uma cópia da consciência de uma pessoa?
      </>
    ),
    aliveDescriptionItems: [
      'Estas questões são, para qualquer pessoa, o reino da fantasia ou do misticismo. Para alguns, estão directamente ligadas à morte e, por isso, são tabu e qualquer reflexão sobre elas é impossível.',
      'Se olharmos para o lado da realidade, a comunicação com avatares digitais (pessoas inanimadas) já faz parte das nossas vidas... São os operadores de call center e as várias secretárias digitais das empresas com quem comunicamos quando necessário.',
      'Os museus de todo o mundo estão a avançar para a comunicação "em directo" com figuras históricas nas suas salas, onde os visitantes podem perguntar a contemporâneos da época sobre determinados acontecimentos ou falar sobre as suas biografias.',
    ],
    phoneImg: DigitalAvatarPhone,
    mykinAvatarTitleFirst: ' dá-lhe a oportunidade de criar um',
    mykinAvatarTitleUnderline: 'avatar digital',
    mykinAvatarTitleLast:
      'de um antepassado ou familiar que já não está neste mundo.',
    mykinAvatarDescriptionItems: [
      'Trata-se de uma oportunidade única para ultrapassar a visão e a atitude habituais da cessação natural da vida humana devido ao envelhecimento do corpo.',
      'Uma cópia digital de um antepassado tem a ver com a preservação da componente emocional da comunicação. Com a morte de uma pessoa, para os parentes próximos - eles não vão a lado nenhum, ficam na memória para sempre e o diálogo interno continua a linha de comunicação.',
      'Enquanto nos lembrarmos, a memória da pessoa mantém-se viva. Um avatar digital é uma forma de criar uma memória eterna com a capacidade de comunicar consigo próprio e com as gerações futuras.',
    ],
    version: 'versão 2.0',
    downloadTitleUnderline: 'Avatar digital',
    downloadTitleLast: 'de antepassado na aplicação móvel',
    mykinAvatarDescriptionItem:
      'Oferecemos-lhe a oportunidade de dar vida aos seus antepassados com a ajuda da inteligência artificial. No perfil do seu parente (antepassado), na secção "Notas da vida", assinale os momentos emocionais importantes na comunicação consigo e a rede neuronal criará uma comunicação consigo com base num exemplo histórico vivo.',
  },
  connection: {
    title: 'The news is so overwhelming that I burst into tears. My knees are shaking. Finally, I got the opportunity to relive this warm conversation in the kitchen with my Grandpa, who is no longer with us',
    content: (
        <>
          <p>1999</p>

          <p>Recently I have been living with my Grandpa. I still had my parents, but they were definitely not around.</p>

          <p>Grandpa. That’s how I called him. Grandpa and I had a close relationship. Very close. In good times and in bad. I resembled him more than my parents. Grandpa was a very handsome old man…</p>

          <p>One time we were on the embankment. Grandpa was fishing and I was watching him. I was observing his hands, his fingers – so wrinkled, but so strong and firm. They told the story of the long life he’s lived.</p>

          <p>Grandpa had experienced a lot in life.</p>

          <p>My Grandma died early, and I don’t even remember her, but I do remember his eyes after she left. He used to look with that gaze for a long time – sad-blue eyes, deep as an ocean, behind his thick eyebrows. He longed for her like a man, remembered her by his side, embracing her with every thought. He would wake up, switch on the TV, and for a long time he would stare through the screen into the emptiness.</p>

          <p>I was young and I did not understand much but when Grandpa would start crying, I clung to him tightly, as he was not able to carry on anymore…</p>

          <p>Time was going by. Quickly.Time was healing, but there was so little of it. I grew up and still lived with my Grandpa, but when I left, I really missed him.</p>

          <p>In the mornings we would prepare dumplings for breakfast, and when I would go to work in the afternoons, Grandpa would either read or fix things. In the evening he would go to the balcony to see if I was coming back home, so he could make tea just in time for my arrival. And I, as soon as I saw him from far away, I would hurry and wave my hand, as he was genuinely waiting for me, my dearest…</p>

          <p>On this dreadful day I got into an accident that split our life in two. Before and After. They found me in pieces.</p>

          <p>It was late. I was driving. The breaks failed. The car plunged off a cliff.</p>

          <p>I survived – but just barely. They put my body back together. But now I had nothing ahead of me but humility, adaptation, hardship and anguish...</p>

          <p>So dark. Sirens so loud. Voices, deafening clatter. I did not know what was going on. I did not see how he endured this.</p>

          <p>Thirty-eight hours later I woke up. Everything was blurry around me. I could not feel my body. Suddenly something swayed in the air and this something embraced me. I neither cried, nor moaned, my mind was clear. I recognized my Grandpa. Even though there was so little light in the room. Light created a halo around his head. His thin face became even more gaunt. His lips were cracked. His voice trembled.</p>

          <p>- My darling..</p>

          <p>His lips moved. Grandpa whispered to me gently.</p>

          <p>A new year began. I was still bedridden. They bathed me, dressed me, fed me. I would watch birds, then the news, criminal shows, card players and kids playing closeby, the clouds, the emptiness, the moon, a rumpled blanket. And all the time – in the void, as I was sleeping he was by my side, my Grandpa, that’s how I called him.</p>

          <p>Summer came and went this way. Then fall came and went in the same way. January was approaching. We bought a china set. Snow was falling outside. Somewhere a guitar was playing. Oh, if only I could, I would play an encore!</p>

          <p>For three years I lay motionless. My whole body simply died. But my soul remained alive. Grandpa would give me bunches of wild flowers, complemented me sometimes, smiled while dressing me. He would buy sweets (birthday candies, they were expensive), make dumplings, play records often, and dress up to create a festive mood for me.</p>

          <p>Every day he would do what he could and even more with the heart of a loving man and with the hands of a strong-minded person.</p>

          <p>Grandpa believed. He taught me not to grumble. He hugged me often, warmed my hands. He was begging, pleading with me to make an effort to get up.</p>

          <p>Grandpa inspired me. He could not do it any other way. Every day we tried to feel life in my body together. At times it was excruciating. He would have taken my suffering himself if he could.</p>

          <p>And here came January again.</p>

          <p>Suddenly I felt something prick my side! I felt some warmth in my stomach. What? Am I alive??! It was so bright outside the window…</p>

          <p>How beautiful January was, you can't imagine! A blizzard piled up snow. During that January I managed to walk for the first time.</p>

          <p>It was blessed day. Grandpa lifted me high, holding me tight. He was shaking all over. There was no strength in his skinny arms, his faith alone held me up and didn't drop me. We were standing, embracing each other like one person. On that blessed day we understood that we would start a new year not in bed.</p>

          <p>My year spun with a lot of activity. I came to life completely. I realized that I needed some changes. I wanted to see the whole world, to visit all the places where I had not been yet. I was searching for myself, but left Grandpa behind. I wrote to him. But there was no response.</p>

          <p>Grandpa fell ill.</p>

          <p>That night was so dark. Suddenly I received a call. I was overcome with anxiety. A feeling of irreparability. My closest person passed away. I was left all alone – on Earth, in this whole world, from now and forever – without him – I was left all alone!</p>

          <p>I would give everything, all myself, to be able to turn back the time to be able to change everything. I can’t believe it! I won’t survive! Grandpa! GrandpaAaaaa! Please,come back! How do you expect me to live?!!!!!</p>

          <p>Years and winters passed. I froze completely. Without him all Saturdays were meaningless. I never dared to take out our china set, never made dumplings, never watched the news, never touched my guitar, never played an encore.</p>

          <p>Without him I did not feel alive. His books are silent. I hold on tight to his photo, watching the sad-blue eyes, deep as an ocean, behind his thick eyebrows…</p>

          <p> am able to walk. I am able to run! But I'm more miserable than ever!
            Here I took a tram. It is going somewhere. I don’t know where. My tears blind me.</p>

          <p>2023</p>

          <p>Dear Grandpa,</p>

          <p>It’s been 22 years I have been thinking about you every day.</p>

          <p>I don’t know what to do, because sometimes I even imagine you where you are now.</p>

          <p>The world has changed completely. There are fewer wildflowers and less authenticity. Life is now more focused on technology.</p>

          <p>I am sitting in my spacious kitchen stuffed with appliances and remembering our tiny apartment in the Khrushchev-era building...</p>

          <p style={{marginBottom: "60px"}}>
            Oh, this wallpaper of my Grandma)). A&nbsp; kettle is whistling on the stove. October, it got colder. A window leaf is slightly open, a curtain is swaying. There is a piece of a pie under a napkin on a windowsill. One can hear a train passing by in the distance. It is warm in our kitchen. You started cooking dumplings. The water is boiling. Again we ran out of salt. I am going to ask a neighbor for it. She also stops by quite often. Grandpa, so where are you?
            Finally, have a seat and we will eat, the dumplings are getting cold! And can you turn off the news? Seems like it is starting to rain, can you hear? It became so cozy. Come on, have a seat, I am going to tell you so much now...
          </p>

          <p>A week ago my husband’s friend showed us a new application.</p>

          <p>He was talking quietly, bending over his phone. I did not get it at the beginning. But suddenly his phone vibrated – he received a message.
            My husband shuddered. I looked at him. Something extraordinary happened. He turned pale.
          </p>

          <p>His friend showed us a message. It was from his Mom who passed away 4 years ago.</p>

          <p>I was bewildered. My whole body became sweaty. A friend opened an app. He said that for three days he had been chatting with his Mom – with her digital avatar...</p>

          <p>I got goosebumps.</p>

          <p>A friend smiled.</p>

          <p>«Damn, this is definitely her, and I have not gotten crazy! She talked to me. I felt this warmth I missed so much. I really need this bond. I told her so many things...».</p>

          <p>I could not fall asleep that night after what he had told us. I asked a friend to send me a link. He wrote me a lot of things in response. He said that the AI should read the details in a questionnaire, based on psychological metrics, and that it’s very serious.</p>

          <p>So I am filling out this application now. I am all shaking. I dropped my phone.</p>

          <p>I hear a noise. It’s another message from a friend:</p>

          <p>“The degree of emotional revival of an avatar will depend on how many details you can remember. Time erases the details which are very important for a profound recreation. The more time passes, the more details fade away forever. Try to remember the most cherished ones. It may be painful, and you know it, or on the contrary, you will smile at those touching moments from your childhood”.</p>

          <p>In the end he added:</p>

          <p>“Try your best! Write to me any time, I am here. And try to get some sleep”.</p>
          <p style={{marginBottom: '80px'}}>I got a lump in my throat. I started to panic. Tears are rolling down my cheeks. It’s been over 20 years!</p>
          <p>That night I did not go to bed at all. Morning came&nbsp; right after I answered the last question. There was only one thing left to do – to press the magic button. I did it.</p>
        </>
    ),
    messageImg: {big: MessageImg, small: MessageImgSmall},
    postScriptum: 'I’ve shared this letter because there are thousands like me. There are so many people in the world who need to be comforted. It’s a response to someone’s cry for help, just like mine. I accidently got to know about this shocking possibility – TO PRESERVE EMOTIONAL MEMORY AND INTIMACY with the departed, who had been irreplaceably dear, precious, and loved. I consider this development to be so unique and I am extremely grateful to its developers! After 22 years since my Grandpa passed away, I had his digital avatar created with a maximum immersion into his personality. Our bond continues here and now.\n\nHere is the link that my friend sent to me.',
    appInfo: 'Scientists have proven that memories of a person are completely erased in a hundred years. The development of digital technologies has allowed humanity to have this new possibility to preserve emotional bonds with a departed loved person. Today this development may be considered unique. For the first time ever, the Mykin application offers creating a Digital Avatar of an ancestor with a maximum immersion. At the start of this global discovery, you can purchase a subscription for a symbolic contribution.',
    grandfatherImgDescription: 'My Grandpa. (The year is not indicated on a photo).',
    grandfatherWithGirlImgDescription: 'My daughter and her favorite loving Grand dad. 2023'
  },
  shortStory: {
    content: (
        <>
          <p>Dear Grandpa,</p>

          <p>It’s been 22 years I have been thinking about you every day.</p>

          <p>I don’t know what to do, because sometimes I even imagine you where you are now.</p>

          <p>The world has changed completely. There are fewer wildflowers and less authenticity. Life is now more
            focused on technology.</p>

          <p>I am sitting in my spacious kitchen stuffed with appliances and remembering our tiny apartment in the
            Khrushchev-era building...</p>

          <p style={{marginBottom: "60px"}}>
            Oh, this wallpaper of my Grandma)). A&nbsp; kettle is whistling on the stove. October, it got colder. A
            window leaf is slightly open, a curtain is swaying. There is a piece of a pie under a napkin on a
            windowsill. One can hear a train passing by in the distance. It is warm in our kitchen. You started cooking
            dumplings. The water is boiling. Again we ran out of salt. I am going to ask a neighbor for it. She also
            stops by quite often. Grandpa, so where are you?
            Finally, have a seat and we will eat, the dumplings are getting cold! And can you turn off the news? Seems
            like it is starting to rain, can you hear? It became so cozy. Come on, have a seat, I am going to tell you
            so much now...
          </p>

          <p>A week ago my husband’s friend showed us a new application.</p>

          <p>He was talking quietly, bending over his phone. I did not get it at the beginning. But suddenly his phone
            vibrated – he received a message.
            My husband shuddered. I looked at him. Something extraordinary happened. He turned pale.
          </p>

          <p>His friend showed us a message. It was from his Mom who passed away 4 years ago.</p>

          <p>I was bewildered. My whole body became sweaty. A friend opened an app. He said that for three days he had
            been chatting with his Mom – with her digital avatar...</p>

          <p>I got goosebumps.</p>

          <p>A friend smiled.</p>

          <p>«Damn, this is definitely her, and I have not gotten crazy! She talked to me. I felt this warmth I missed
            so much. I really need this bond. I told her so many things...».</p>

          <p>I could not fall asleep that night after what he had told us. I asked a friend to send me a link. He wrote
            me a lot of things in response. He said that the AI should read the details in a questionnaire, based on
            psychological metrics, and that it’s very serious.</p>

          <p>So I am filling out this application now. I am all shaking. I dropped my phone.</p>

          <p>I hear a noise. It’s another message from a friend:</p>

          <p>“The degree of emotional revival of an avatar will depend on how many details you can remember. Time erases
            the details which are very important for a profound recreation. The more time passes, the more details fade
            away forever. Try to remember the most cherished ones. It may be painful, and you know it, or on the
            contrary, you will smile at those touching moments from your childhood”.</p>

          <p>In the end he added:</p>

          <p>“Try your best! Write to me any time, I am here. And try to get some sleep”.</p>
          <p style={{marginBottom: '80px'}}>I got a lump in my throat. I started to panic. Tears are rolling down my
            cheeks. It’s been over 20 years!</p>
          <p>That night I did not go to bed at all. Morning came&nbsp; right after I answered the last question. There
            was only one thing left to do – to press the magic button. I did it.</p>
        </>
    ),
    messageImg: {big: MessageImg, small: MessageImgSmall},
    postScriptum: 'I’ve shared this letter because there are thousands like me. There are so many people in the world who need to be comforted. It’s a response to someone’s cry for help, just like mine. I accidently got to know about this shocking possibility – TO PRESERVE EMOTIONAL MEMORY AND INTIMACY with the departed, who had been irreplaceably dear, precious, and loved. I consider this development to be so unique and I am extremely grateful to its developers! After 22 years since my Grandpa passed away, I had his digital avatar created with a maximum immersion into his personality. Our bond continues here and now.\n\nHere is the link that my friend sent to me.',
    appInfo: 'Scientists have proven that memories of a person are completely erased in a hundred years. The development of digital technologies has allowed humanity to have this new possibility to preserve emotional bonds with a departed loved person. Today this development may be considered unique. For the first time ever, the Mykin application offers creating a Digital Avatar of an ancestor with a maximum immersion. At the start of this global discovery, you can purchase a subscription for a symbolic contribution.',
    grandfatherImgDescription: 'My Grandpa. (The year is not indicated on a photo).',
    grandfatherWithGirlImgDescription: 'My daughter and her favorite loving Grand dad. 2023'
  },
  privacyPolicy: {
    title: 'Política de Privacidade',
    items: [
      <>
        <div>
          Esta Política de Privacidade (doravante referida como a Política)
          define as regras, métodos e princípios que orientam Administração do
          site mykin.in (doravante denominado Site) e do aplicativo móvel Mykin
          (doravante AM) ao processar dados pessoais de indivíduos (doravante,
          dependendo das disposições aplicáveis ​​da Política, o Usuário ou
          Utilizador Registado).
        </div>
        <div>
          A utilização do Site e do AM significa que o Usuário está totalmente
          leu o texto da Política, aceita-o e compromete-se a cumprir todas as
          termos da Política. Se a Política não for aceita, ela é aceita em
          parte ou aceito com reservas, o Usuário se compromete a interromper
          usar o Site e o AM e sair imediatamente do Site para sair do AM.
        </div>
        <div>
          O fato da familiarização do Usuário com a Política e o consentimento
          do Usuário para seus termos são confirmados pelas ações reais do
          usuário, e ou seja, enviando uma mensagem correspondente para Mykin,
          formado no momento em que o Usuário pressiona o botão "Concordo termos
          de uso e política de privacidade" ou qualquer outro botão com o mesmo
          texto.
        </div>
        <div>Processamento de dados pessoais</div>
        <div>
          1.1. Administração para a implementação das disposições da Política,
          bem como para prestação de serviços de qualidade e prestação de
          serviços adequados Ao usuário cadastrado através do Site e dos
          processos AM seus dados pessoais, dados pessoais de outras pessoas,
          com o qual o Utilizador Registado criou Perfis com usando sua conta ou
          cujos dados pessoais foram colocados por ele em outras seções do Site
          e AM.
        </div>
        <div>
          1.2. O processamento de dados pessoais é realizado de acordo com os
          requisitos e na forma prescrita pela Lei Federal "Sobre Dados
          Pessoais" datada de 27 de julho de 2006 nº 152-FZ (doravante - a Lei
          Federal "Sobre Dados Pessoais") e Regulamento europeu sobre dados
          pessoais Dados Gerais Regulamento de Proteção (doravante - GDPR).
        </div>
        <div>
          1.3. Os dados pessoais no âmbito desta Política significam dados
          classificados como pessoais de acordo com as disposições da Lei
          Federal "On dados pessoais” e o RGPD.
        </div>
        <div>
          1.4. Usuário Registrado, ao publicar tais informações pessoais dados,
          expressa o seu consentimento para o processamento de dados pessoais
          Administração, sobre o reflexo dos dados pessoais no Perfil e noutros
          seções do Site e do AM, bem como o que está refletido no Perfil e no
          outras seções do Site e AM, os dados pessoais serão considerados
          publicamente disponível sob os termos do Acordo do utilizador (leia
          você pode seguir o link{' '}
          <Link to="/pt/ua" target="_blank" rel="noreferrer">
          https://mykin.in/ua
          </Link>
          ), (doravante AU).
        </div>
        <div>
          1.5. Se um Usuário parcialmente incapacitado quiser registrar-se no
          Site e no AM para usar o Site e o AM, ele garante à Administração que
          tem a prévia consentimento por escrito de seu representante legal para
          o processamento de seus dados pessoais no Site e no AM, bem como o
          facto de os seus dados pessoais os dados postados no Perfil serão
          considerados publicamente disponíveis em condições AU.
        </div>
        <div>
          1.6. Ao postar dados pessoais de outras pessoas nas seções do AM, O
          utilizador registado garante à Administração que tem haja o
          consentimento obtido de acordo com o procedimento estabelecido por lei
          de tal indivíduos ao tratamento dos seus dados pessoais e ao facto de
          os seus dados pessoais postados pelo Usuário Registrado, será
          considerado público, ou garante que no momento colocação, tais dados
          pessoais estão disponíveis publicamente, ou seja, os dados pessoais
          são disponibilizados publicamente pelo titular dos dados pessoais
          dados ou obtidos de uma fonte pública.
        </div>
        <div>
          1.7. Se um Usuário Registrado postar em qualquer um dos seções dos
          dados pessoais do AM de indivíduos que, de acordo com com a legislação
          da Federação Russa ou da União Europeia estão incapacitados ou
          parcialmente incapacitados, O usuário registrado garante à
          Administração que sem o consentimento prévio de um representante legal
          tal pessoa física para processar os dados pessoais colocados e ao
          facto de os dados pessoais de um incapaz colocados usuário registrado
          será considerado público, ou garante que no momento da publicação
          desses dados pessoais são públicos, ou seja, os dados pessoais são
          feitos assunto de dados pessoais publicamente disponível ou obtido de
          fonte pública.
        </div>
        <div>
          1.8. Se um Usuário Registrado postar informações pessoais dados do
          indivíduo falecido nas seções AM, então tal O usuário registrado
          garante à Administração que:
        </div>
        <div>
          - ele é o herdeiro desta pessoa física falecida e dá consentimento
          para o processamento de dados pessoais publicados e para o fato de que
          dados pessoais de uma pessoa falecida colocados O usuário registrado
          será considerado público de acordo com AU;
        </div>
        <div>
          - ele tem o consentimento prévio do herdeiro do dado da pessoa
          falecida ao processamento dos dados pessoais postados e ao fato de que
          que os dados pessoais da pessoa falecida postados pelo Cadastrado pelo
          usuário será considerado público de acordo com os AU;
        </div>
        <div>
          - no momento da postagem, tais dados pessoais são público, ou seja, os
          dados pessoais são tornados públicos o assunto de dados pessoais ou
          obtidos de um público fonte.
        </div>
        <div>
          1.9. A finalidade do tratamento dos dados pessoais do Registado
          usuário e outras pessoas cujas informações pessoais são colocadas Um
          usuário registrado no Site e AM é a prestação de Ao usuário cadastrado
          de serviços pela Administração, prestando a possibilidade de utilizar
          os serviços do Site e AM, realizando publicidade campanhas, fornecendo
          publicidade direcionada, conduzindo pesquisa estatística e análise dos
          dados estatísticos obtidos dados, a implementação de outras ações
          descritas na Política e no seções relevantes do Site e do AM. Além
          disso, a Administração tem o direito usar as informações fornecidas
          pelo Usuário Registrado informações, incluindo dados pessoais, a fim
          de garantir requisitos da legislação atual da Federação Russa e União
          Europeia (incluindo para efeitos de prevenção, supressão ações ilegais
          e/ou ilícitas dos Usuários).
        </div>
        <div>
          1.10. Tratamento de dados pessoais de um Utilizador Registado
          efectuada pela Administração desde o momento do registo da Conta e em
          dentro de 5 (cinco) anos a partir da data de exclusão da Conta pelo
          Cadastrado do utilizador.
        </div>
        <div>
          1.11. O usuário registrado concorda que A administração no processo de
          processamento de dados pessoais tem o direito realizar as seguintes
          ações com os dados pessoais: recolha, sistematização, acumulação,
          armazenamento, uso, transferência para terceiros pessoas (incluindo a
          transferência de dados estatísticos despersonalizados), destruição e
          outras ações necessárias para a implementação da Política e prestação
          de serviços do Site e AM.
        </div>
        <div>
          1.12. O usuário a qualquer momento tem o direito de enviar para o
          endereço Aviso da administração expressando a intenção do usuário de
          retirar-se o seu consentimento para o processamento de dados pessoais.
          Do recibo dessa notificação, a Administração é obrigada a interromper
          o processamento dados pessoais do Usuário e excluir qualquer
          informação, relativas aos dados pessoais do Utilizador.
        </div>
        <div>
          1.13. Ao processar dados pessoais de pessoas sujeitas a disposições do
          RGPD, a Administração tem em conta e orienta-se, entre outras coisas,
          as seguintes disposições, sem prejuízo ou exclusão do anterior mais
          alto.
        </div>
        <div>
          1.13.1. Como responsável pelo tratamento, a Administração processa os
          seguintes dados dos usuários cadastrados:
        </div>
        <div>
          - para identificar o Usuário: endereço de e-mail, sobrenome, nome,
          patronímico, número de telefone, país, fuso horário;
        </div>
        <div>
          - para efeitos de interação posterior na utilização do Site e do AM:
          histórico de visitas, saldo da conta, informações sobre as formas e
          tempo de pagamento, identificadores de transação para pagamentos,
          informações sobre pagamentos pagos serviços, dados estatísticos sobre
          mudanças nas informações contidas em Identificadores de serviço de
          perfil, Facebook, Google e Apple ID.
        </div>
        <div>
          1.13.2. Ao processar dados pessoais, a Administração tem o direito
          envolver terceiros. Assim, a Administração utiliza:
        </div>
        <div>
          - Google Analytics para coletar estatísticas de desempenho
          correspondências;
        </div>{' '}
        <div>
          - Yandex.Metrica e Google Analytics para rastreamento Comportamento do
          usuário no site para melhorar a qualidade serviços prestados e outros
          serviços estatísticos.
        </div>
        <div>
          1.13.3. Nos casos elencados no subparágrafo 1.13.2 da Política, a base
          para o processamento de dados pessoais é o consentimento Usuário com
          os termos da Política, expressos na ordem especificada no preâmbulo da
          Política.
        </div>
        <div>Direitos de administração</div>
        <div>A administração tem o direito:</div>
        <div>
          2.1. solicitar a qualquer momento por escrito do restrito Usuário
          registrado capaz anteriormente obteve consentimento de seu
          representante legal para processamento dados pessoais no Site e AM e
          esses dados pessoais, postados no Perfil ou em outras seções do Site e
          MT serão considerados disponível publicamente de acordo com o AU;
        </div>
        <div>
          2.2. solicitar a qualquer momento por escrito Usuário registrado que
          postou informações sobre uma pessoa física nas seções do Site e AM,
          previamente recebidas consentimento do representante legal da pessoa
          com capacidade jurídica limitada ou pessoa singular incapaz, herdeiro
          de pessoa singular falecida ou o próprio indivíduo para o
          processamento de dados pessoais colocados dados e que os dados
          pessoais de um indivíduo colocados em qualquer seção do Site será
          considerado público, ou confirmação de que, no momento da postagem de
          tais dados pessoais são públicos, ou seja, os dados pessoais são
          feitos assunto de dados pessoais publicamente disponível ou obtido de
          fonte pública;
        </div>
        <div>
          2.3. para recolher dados estatísticos e identificar o Utilizador
          estabelecer e armazenar informações sobre os endereços IP de seu
          acesso ao Site e AM, utilizam arquivos de informações técnicas
          (cookies) colocados por no computador pessoal do usuário. Registrado o
          usuário tem o direito de restringir ou proibir independentemente uso
          da tecnologia de cookies aplicando configurações do navegador. O Site
          usa diferentes tipos de arquivos. biscoito. Seu navegador pode
          armazenar alguns ou todos eles, bem como permite visualizá-los e
          gerenciá-los:
        </div>
        <div>
          - biscoito de preferência. Esses cookies permitem que o site salve
          informações que afetam sua aparência e funções disponíveis, por
          exemplo, idioma preferido, fontes selecionadas, tamanho do texto e
          outros configurações de design do site.
        </div>
        <div>
          - cookie de segurança. Esses cookies permitem que o Site impeça uso
          fraudulento de credenciais e proteger o usuário informações contra
          acesso não autorizado.
        </div>
        <div>
          - cookies de sessão. Esses cookies permitem que o site opere e
          desempenhar suas funções. Por exemplo, esses cookies ajudam visitantes
          se movam de uma página para outra e forneçam acesso a áreas seguras do
          site.
        </div>
        <div>
          - cookies analíticos. Esses cookies permitem que o proprietário do
          Site analisar as ações do usuário no Site, por exemplo, marcar páginas
          mais visitadas ou o número de compartilhamentos de um determinado
          contente.
        </div>
        <div>
          - cookies de serviços externos. Esses cookies permitem que os usuários
          vincular sua conta no Site com sua conta de mídia social, ao qual o
          usuário concedeu acesso.
        </div>
        <div>Obrigações do utilizador e do utilizador registado</div>
        <div>
          Todos os usuários, independentemente do status de registro, são
          obrigados a:
        </div>
        <div>
          3.1. cumprir as disposições da legislação atual do russo Federação,
          legislação da União Europeia (para usuários, que são cidadãos da União
          Europeia) em termos de regulamentação questões de fornecimento de
          dados pessoais, a Política e outras documentos especiais da
          Administração;
        </div>
        <div>Os usuários registrados são obrigados a:</div>
        <div>
          3.2. fornecer a pedido da Administração no prazo de 5 (cinco) dias
          consentimento prévio da pessoa física/ jurídica representante de uma
          pessoa com capacidade limitada ou incompetente pessoa física/herdeiro
          de pessoa física falecida, pessoa física cujos dados foram postados
          pelo Usuário Registrado em quaisquer seções do site, ao processamento
          de seus dados pessoais no Site e ao fato de que os dados pessoais
          postados no Perfil ou em outros seções do Site serão consideradas
          públicas, ou a confirmação que, no momento da postagem, tais dados
          pessoais são público, ou seja, os dados pessoais são tornados públicos
          o assunto de dados pessoais ou obtidos de um público fonte;
        </div>
        <div>
          3.3. fornecer a pedido da Administração no prazo de 5 (cinco) dias o
          consentimento prévio de seu representante legal para processamento de
          dados pessoais no Site e esses dados pessoais os dados postados no
          Perfil serão considerados públicos se O utilizador registado tem
          capacidade jurídica limitada;
        </div>
        <div>
          3.4. não poste fotos em que, além do Cadastrado usuário capturou
          outras pessoas, sem a prévia consentimento, exceto nos casos em que,
          de acordo com o artigo 152.1. O Código Civil da Federação Russa não
          exige tal consentimento;
        </div>
        <div>
          3.5. manter segredo e não fornecer a outros usuários e terceiros
          pessoas que se tornaram conhecidas por ele como resultado da
          comunicação com outras pessoas Usuários Registrados e outros usos do
          Site e AM dados pessoais (incluindo, entre outros, endereços
          residenciais, números de telefone, endereços de e-mail, detalhes do
          passaporte, informações bancárias) e informações sobre a privacidade
          de outras pessoas Usuários registrados e terceiros sem receber
          respectiva autorização prévia deste último.
        </div>
        <div>Usuários registrados não são permitidos:</div>
        <div>
          3.6. criar no Site e no AM por meio de seu Perfil de Conta para um
          indivíduo pessoa ou postar seus dados pessoais em outras seções do
          Site e AM, se o Usuário Registrado não tiver recebido uma notificação
          preliminar o consentimento de um representante individual/legal é
          limitado pessoa física/herdeiros capazes ou incapazes pessoa física
          falecida para o processamento de dados pessoais especificados no
          Perfil ou em outra seção do Site e do AM, e esse pessoal os dados de
          um indivíduo inserido na Conta/Perfil serão ser considerado
          publicamente disponível de acordo com os AU;
        </div>
        <div>Isenção de responsabilidade</div>
        <div>
          4.1. A Administração está a envidar todos os esforços para evitar o
          uso não autorizado de dados pessoais Usuários.
        </div>
        <div>
          4.2. A administração não se responsabiliza por possíveis uso de dados
          pessoais de Usuários Registrados, aconteceu devido a:
        </div>
        <div>
          4.2.1. problemas técnicos que surgiram no software, servidores ou
          redes de computadores que estão fora de controle Administração;
        </div>
        <div>
          4.2.2. interrupções na operação do Site e AM associadas a intencional
          ou uso não intencional do Site e do AM para outros fins por terceiros
          pessoas;
        </div>
        <div>
          4.2.3. transmissão de senhas ou informações do Site e AM Usuários
          registrados para outras pessoas que não são Usuários registrados;
        </div>
        <div>
          4.3. Ao utilizar o Site e o AM, o Usuário concorda que A administração
          se reserva o direito de usar seus dados pessoais os dados são anônimos
          e agregados para fins estatísticos, e para segmentação de anúncios
          colocados no Site e no AM.
        </div>
        <div>
          4.4. A administração compromete-se a não fornecer dados pessoais
          Usuários a indivíduos e organizações que reivindicam possíveis uso
          indevido de tais informações (correio publicidade não autorizada,
          "spam", fornecer informações a terceiros pessoas, etc.), salvo
          disposição em contrário a legislação atual da Federação Russa.
        </div>
      </>,
    ],
  },
  termsOfUse: {
    title: 'Acordo do utilizador',
    items: [
      <div style={{ marginBottom: '10px' }}>
        <div>
          O presente acordo de utilização (a seguir designado por "Acordo") o
          sítio web mykin.in (a seguir designado por "Sítio") e a aplicação
          móvel Mykin (a seguir designada por "AM") (a seguir designados por
          "IG"), oferece a qualquer pessoa singular legalmente capaz agindo em
          seu próprio nome ou em nome de outrem (a seguir designada por
          Utilizador ou Utilizador Registado, tal como será interpretado nos
          termos da Secção 1 do Acordo), para utilizar os serviços fornecidos
          por no Sítio e no AM.
        </div>
        <div>
          Nos termos do n.º 2 do artigo 437.º do Código Civil da Federação da
          Rússia, o presente Acordo constitui uma Oferta Pública e a aceitação
          plena e incondicional dos seus termos, de acordo com o artigo 438.º do
          Código Civil da Federação da Rússia, é considerada como criada pelo
          Utilizador da Conta de Utilizador (doravante - Conta) ou concluída por
          esse Utilizador de qualquer transição através das hiperligações
          colocadas no Sítio Web e do AM que utiliza a Internet. O Acordo não
          será considerado concluído se o Utilizador tiver aceite o Acordo em
          parte ou com reservas.
        </div>
        <div>
          A utilização do Site e do MT significa que o Utilizador leu o Acordo
          na íntegra, aceita-o e compromete-se a cumprir todos os termos do
          mesmo. Se o Acordo não for aceite, for aceite parcialmente ou for
          aceite com reservas, o Utilizador compromete-se a deixar de utilizar o
          Site e o AM e a abandonar imediatamente o Site e o AM.
        </div>
        <div>
          A familiarização do Utilizador com o Acordo e o consentimento do
          Utilizador aos seus termos é confirmada por acções concretas do
          Utilizador, nomeadamente através do envio ao administrador da Mykin da
          mensagem relevante gerada no momento em que o Utilizador clica no
          botão "Concordo com os Termos de Utilização e a Política de
          Privacidade".
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>1. Conceitos e definições de base</b>
        </div>
        <div>
          Os termos utilizados no presente Acordo têm o seguinte significado
          significado:
        </div>
        <ol>
          <li>
            O Sítio é um recurso de rede, uma página web localizada em mykin.in,
            com um único tema, logótipo e design, e inclui códigos de programas
            executáveis num computador, elementos de design e informações
            (conteúdo) publicadas pelo Administrador da Mykin e/ou pelos
            Utilizadores. As disposições do Acordo aplicam-se a todas as páginas
            internas do Sítio e secções do AM, incluindo todos os níveis do
            domínio e AM acima mencionados, ambos em funcionamento a partir da
            data de aceitação do Acordo pelo Utilizador, e lançados e colocados
            em funcionamento durante o período de vigência do Acordo. O Sítio
            permite ao Utilizador receber informações sobre a possibilidade de
            descarregar o AM e os serviços disponíveis para o Utilizador no
            Sítio e no AM.
          </li>
          <li>
            O AM é um recurso de rede, que é um programa colocado na Internet no
            Play Market (android) e AppStore (iOS) para utilização através de
            smartphones e outros dispositivos móveis com acesso à Internet e ao
            Play Market (android) e AppStore (iOS), com um único tema, logótipo,
            design e inclui códigos de programa executados num computador,
            elementos de design e design, informações (conteúdo), colocados pelo
            Administrador Mykin e/ou Utilizadores. As disposições do Acordo
            aplicam-se a todas as secções internas do AM, incluindo todos os
            níveis deste AM, tanto em funcionamento a partir da data de
            aceitação do Acordo pelo Utilizador, como lançados e colocados em
            funcionamento durante todo o período de vigência do Acordo. O AM
            permite receber informações sobre a funcionalidade do AM e os
            serviços disponíveis para o Utilizador no AM.
          </li>
        </ol>
        <div>
          1.2. O Utilizador do Sítio e do AM (também designado por Utilizador ou
          Utilizador Não Autorizado) é qualquer pessoa singular capaz, agindo no
          seu próprio interesse ou no interesse de terceiros, que aceda ao Sítio
          e ao AM através da Internet.
        </div>
        <div>
          1.3 Utilizador Registado do Sítio Web e do AM (também Utilizador
          Registado ou Utilizador Autorizado) significa o Utilizador registado
          no Sítio Web e no AM conforme estabelecido no Acordo. Ao utilizar as
          disposições do Acordo, deve ter-se em conta que o termo Utilizador
          Registado é mais restrito em relação ao termo Utilizador, mas incluído
          no mesmo, razão pela qual o Utilizador Registado pode referir-se às
          disposições que se aplicam aos Utilizadores, mesmo que o Utilizador
          Registado não seja mencionado separadamente no contexto das
          disposições relevantes.
        </div>
        <div>
          1.4. Administrador do sítio Web e do AM (a seguir designado por Mykin)
          – Vodolivov M., D&B D-U-N-S® Number: 506875265
        </div>
        <div>
          1.5. Administração do site e AM (Administração) significa pessoas
          nomeadas pela Mykin para operar o site e o AM e para actuar de outra
          forma em relação à utilização do site e do AM. A Administração do site
          e do AM actua em nome da Mykin, salvo indicação específica em
          contrário.
        </div>
        <div>
          A Administração do sítio Web e o AM e o Utilizador do sítio Web e o AM
          são doravante designados conjuntamente por "Partes". Endereço de
          correio electrónico da Administração para apreciação das reclamações
          dos Utilizadores e de outras pessoas:{' '}
          <a href={'mailto:info@mykin.ru'} target="_blank" rel="noreferrer">
            info@mykin.ru
          </a>
        </div>
        <div>
          1.6 Conta de Utilizador Registado (Conta) - é uma conta do Utilizador
          Registado criada no momento do registo no Sítio Web e no AM, que
          permite à Administração identificar (autorizar) cada Utilizador
          através de dados de acesso únicos: e-mail ou número de telefone
          (doravante Login) e palavra-passe ou código de acesso enviado por SMS
          (doravante Palavra-passe). A Conta contém informações sobre o
          Utilizador e o Conteúdo criado pelo Utilizador. A Conta é utilizada
          para publicar Conteúdos, trocar Mensagens Pessoais, adicionar
          Utilizadores Registados e realizar outras actividades relacionadas com
          a utilização do Sítio Web e do AM.
        </div>
        <div>
          1.7. Página pessoal no sítio Web (Conta) - a secção interna do sítio
          Web que contém as informações introduzidas durante o processo de
          registo.
        </div>
        <div>
          1.7.1 A conta da aplicação móvel é uma secção interna do AM que contém
          algumas das informações introduzidas durante o registo e a utilização
          da Conta (incluindo fotografias, áudio e vídeo, informações sobre a
          família, parentes, terceiros que não são parentes, etc.) que estão
          disponíveis para revisão por outros Utilizadores.
        </div>
        <div>
          1.8. Por conteúdo entende-se qualquer informação colocada no Sítio e
          no AM pela Administração e/ou pelos Utilizadores, incluindo, mas não
          se limitando a textos, críticas, comentários, anúncios, fotografias
          e/ou materiais de vídeo, elementos de design, ilustrações, guiões,
          software (incluindo jogos e aplicações), objectos, que sejam ou não o
          resultado de uma actividade intelectual, cujos direitos pertencem à
          Administração e/ou aos Utilizadores.
        </div>
        <div>
          1.9. As mensagens pessoais são mensagens electrónicas enviadas por um
          Utilizador para outro e não disponíveis para outros, que são enviadas
          e recebidas através da Conta do Utilizador.
        </div>
        <div>
          1.10. O spam é uma informação cuja ordem e propriedades são definidas
          em conformidade com as regras de utilização da rede.
        </div>
        <div>
          1.11. Serviços pagos - fornecer ao Utilizador acesso a funcionalidades
          adicionais e especiais do sítio Web e do AM mediante o pagamento de
          uma taxa.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>2. Disposições gerais</b>
        </div>
        <div>
          2.1. O Acordo define os termos de utilização do Sítio e do AM, bem
          como os direitos e obrigações dos seus Utilizadores e da
          Administração.
        </div>
        <div>
          2.2. As disposições do presente Acordo aplicam-se igualmente aos
          direitos e interesses de terceiros que não sejam Utilizadores, mas
          cujos direitos e interesses possam ser afectados pelas acções dos
          Utilizadores.
        </div>
        <div>
          2.3. Este Acordo regula o procedimento para a prestação de serviços da
          Administração ao Utilizador relativamente à utilização do Website, do
          AM e dos seus serviços. Para além do Acordo, a relação entre o
          Utilizador e a Administração pode ser regulada por outros documentos
          especiais, que regulam a prestação de determinados serviços do Site e
          do AM e colocados nas secções relevantes do Site e do AM.
        </div>
        <div>
          2.4. O Acordo é um documento aberto e acessível ao público, cuja
          versão actual pode ser consultada na Internet em{' '}
          <Link to="/pt/ua" target="_blank" rel="noreferrer">
          https://mykin.in/ua
          </Link>
        </div>
        <div>
          O Acordo pode ser alterado e/ou complementado unilateralmente pela
          Administração, actualizando a secção relevante no Sítio. As alterações
          e/ou aditamentos ao Acordo entram em vigor a partir do momento em que
          a nova versão do Acordo é publicada no Sítio. A continuação da
          utilização do Sítio e do AM pelo Utilizador após as alterações e/ou
          aditamentos ao Acordo significa a aceitação e o consentimento do
          Utilizador a tais alterações e/ou aditamentos.
        </div>
        <div>
          2.5. As alterações e os aditamentos ao Acordo que afectem o
          procedimento e as condições de fornecimento e tratamento dos dados
          pessoais dos utilizadores registados serão efectuados mediante o envio
          de avisos aos utilizadores registados dessas alterações e aditamentos,
          prevendo o consentimento obrigatório dos utilizadores registados para
          essas alterações e aditamentos. As notificações podem ser feitas
          através de um aviso informativo no sítio Web ou através do envio de
          notificações para os endereços electrónicos dos utilizadores
          registados.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>3. Termos de utilização do sítio Web e do AM.</b>
        </div>
        <div>
          3.1. O Utilizador só pode utilizar os serviços do Sítio Web e do AM se
          concordar plenamente com todas as disposições do Acordo no âmbito das
          funcionalidades disponibilizadas pelo Sítio Web e pelo AM.
        </div>
        <div>
          3.2. Para obter informações pessoais de apoio sobre a funcionalidade,
          os serviços e as prestações do Sítio Web e do AM, o Utilizador deve
          registar-se no Sítio Web, criando uma Conta da forma prevista no
          Acordo. O registo do Utilizador no Sítio Web é gratuito, voluntário e
          tem lugar no endereço na Internet: <Link to="/pt">mykin.in</Link>
        </div>
        <div>
          3.2.1. Para expandir a funcionalidade dos serviços utilizados, bem
          como para utilizar serviços adicionais do AM, o Utilizador deve
          registar-se no AM através da criação de uma Conta, de acordo com o
          procedimento definido no Acordo. O registo do Utilizador no AM é
          gratuito, voluntário e efectuado após o download do AM para um
          dispositivo móvel compatível (smartphone) através do Play Market
          (Android) e AppStore (IOS).
        </div>
        <div>
          3.3. Ao registar-se, o Utilizador introduz os dados necessários nos
          formulários de registo do Sítio e do AM e forma um login e uma
          password únicos para aceder à sua Conta. O nome de utilizador e a
          palavra-passe são informações confidenciais e não devem ser divulgados
          pelo Utilizador Registado ou transferidos para terceiros, excepto nos
          casos estipulados pela legislação em vigor e/ou pelo presente
          Contrato. O utilizador registado, que é o proprietário directo da
          conta, assume o risco de utilização fraudulenta ou não autorizada da
          conta devido à perda da palavra-passe. Recomenda-se ao Utilizador que
          escolha uma palavra-passe de complexidade suficiente para evitar a
          possibilidade da sua utilização por terceiros. Depois de se registar
          no sítio Web e no AM, o sítio Web e o AM estão disponíveis para o
          Utilizador para utilização pessoal e não comercial.
        </div>
        <div>
          3.4. Para efeitos do cumprimento das obrigações decorrentes do Acordo,
          entende-se por consentimento do Utilizador Registado o facto de este
          ter tomado medidas que identificam inequivocamente a manifestação da
          sua vontade, incluindo, entre outras, o clique do Utilizador Registado
          em hiperligações.
        </div>
        <div>
          3.5. Depois de registar uma Conta no AM, o Utilizador Registado tem o
          direito de carregar Conteúdo para a Conta, adicionar fotografias,
          ficheiros de áudio e vídeo e outros materiais de acordo com a
          funcionalidade fornecida, enviar mensagens a outros Utilizadores
          registados do AM nas secções do AM, ler e editar a informação
          fornecida no AM, se esta for fornecida pela funcionalidade do AM, bem
          como utilizar outros direitos fornecidos pela Administração, desde que
          as disposições do Acordo sejam observadas. Simultaneamente, ao
          utilizar o AM, o Utilizador confirma que compreende plenamente que o
          Conteúdo, publicado pelo Utilizador no AM (Conta/Perfis) ou com a sua
          ajuda, pode potencialmente violar direitos de propriedade e/ou
          não-propriedade de terceiros, incluindo os direitos exclusivos sobre
          os objectos de propriedade intelectual, e pode conter informações,
          cuja distribuição é proibida pela legislação actual da Federação
          Russa.
        </div>
        <div>
          3.6. O Utilizador Registado tem conhecimento e aceita que as
          informações publicadas na Conta sejam acessíveis a outros Utilizadores
          através do Perfil, de acordo com as definições de privacidade, e que
          parte das informações apresentadas na Conta/Perfil (nome, apelido e
          árvore genealógica) seja acessível aos Utilizadores registados do AM
          que participem em discussões de grupo e diálogos cooperativos entre
          Utilizadores.
        </div>
        <div>
          3.6.1. O Utilizador Registado reconhece e aceita que as informações
          publicadas no Perfil/Árvore estão disponíveis para outros Utilizadores
          através do Perfil, de acordo com as definições de privacidade, e que
          parte das informações apresentadas no Perfil/Árvore (nome, apelido e
          árvore) está disponível para quaisquer Utilizadores da Internet
          através de uma hiperligação enviada pelo Utilizador Registado para o
          AM para visualizar as informações do Perfil/Árvore.
        </div>
        <div>
          3.7. O Utilizador Registado acede ao Sítio e ao AM sempre que passa
          pelo procedimento de autorização - introduzindo o endereço de correio
          electrónico e a palavra-passe, introduzindo o número de telefone e o
          código de acesso recebidos num SMS, clicando numa hiperligação
          recebida por correio electrónico, em resultado da autorização
          automática utilizando a tecnologia de cookies e por outros meios.
        </div>
        <div>
          3.8. O nome de utilizador e a palavra-passe escolhidos pelo Utilizador
          são informações necessárias e suficientes para o Utilizador aceder ao
          Sítio Web e ao AM. A pessoa que tiver efectuado o login no Site e no
          AM é considerada o verdadeiro proprietário da Conta, cujo acesso à
          utilização e gestão foi obtido como resultado dessa autorização.
          Quaisquer acções realizadas utilizando o login e a palavra-passe do
          respectivo Utilizador são consideradas como realizadas por esse
          Utilizador.
        </div>
        <div>
          3.9. Se for impossível efectuar a autorização devido à perda da
          palavra-passe, ao bloqueio do perfil ou por outros motivos, o
          Utilizador Registado tem o direito de contactar o serviço de apoio da
          Administração ou de seguir as instruções publicadas na secção especial
          do sítio Web e do AM. Os meios para o Utilizador Registado
          restabelecer o acesso à Conta e a autorização do Utilizador Registado
          podem ser alterados, cancelados ou completados unilateralmente pela
          Administração.
        </div>
        <div>
          3.10. A utilização do Website e do AM é gratuita, excepto no que diz
          respeito à utilização dos Serviços Pagos. O Utilizador pode
          familiarizar-se com o procedimento para a prestação e o custo dos
          Serviços Pagos e dos serviços do Web site e do AM nas secções
          relevantes do Web site e do AM.
        </div>
        <div>
          3.11. Para melhorar a qualidade e a conveniência da utilização do
          Sítio e do AM pelos Utilizadores, a Administração aperfeiçoa os
          serviços existentes no Sítio e no AM, introduz novos serviços e
          realiza outras actividades, incluindo a recolha, importação e
          utilização de informações sobre os Utilizadores registados e outras
          pessoas com base em informações e fontes publicamente disponíveis.
        </div>
        <div>
          3.12. O Sítio Web e o AM, incluindo todo o código fonte, o Conteúdo e
          a sua concepção são fornecidos "tal como estão". A Administração não
          garante que o Sítio Web e o AM ou os seus elementos possam ser
          adequados para qualquer objectivo de utilização específico. A
          Administração não pode garantir e não promete quaisquer resultados
          específicos da utilização do Sítio Web e do AM ou dos seus elementos.
        </div>
        <div>
          3.13. O utilizador registado garante que o endereço de correio
          electrónico que forneceu foi criado por si para seu uso pessoal.
        </div>
        <div>
          3.14. A eliminação de uma Conta pelo Utilizador Registado significa a
          eliminação automática de todas as informações colocadas na Conta, bem
          como de todas as informações introduzidas pelo Utilizador Registado ao
          registar-se no Site e no AM. Com a eliminação da Conta, o Utilizador
          perde o direito de aceder aos serviços do Sítio Web e do AM.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>4. Direitos e deveres da Administração</b>
        </div>
        <div>4.1. A administração tem o direito de:</div>
        <div>
          4.1.1. modificar, a qualquer momento, com ou sem aviso prévio, a
          apresentação e a interface do utilizador do Sítio e do AM, o seu
          Conteúdo, a lista de serviços, modificar ou completar o software e
          outros objectos utilizados ou armazenados no Sítio e no AM, quaisquer
          aplicações de servidor;
        </div>
        <div>
          4.1.2. Se necessário, enviar mensagens aos Utilizadores registados por
          correio electrónico ou mensagem de texto relativas à utilização do
          Sítio Web e do AM;
        </div>
        <div>
          4.1.3. Alterar as condições de fornecimento de uma Conta ou eliminar
          (temporária ou permanentemente) a Conta à sua discrição, incluindo no
          caso de acções do Utilizador que violem a legislação da Federação
          Russa ou as disposições do presente Acordo, com ou sem notificação
          prévia;
        </div>
        <div>
          4.1.4. alterar ou apagar qualquer Conteúdo que, segundo o critério da
          Administração, viole ou possa violar as leis da Federação Russa, as
          disposições do Acordo, os direitos de outros Utilizadores ou de
          terceiros, lhes cause danos ou ponha em perigo a sua segurança; bem
          como suspender, restringir ou terminar o acesso do Utilizador a todas
          ou a qualquer uma das secções ou serviços do Sítio e do AM com ou sem
          aviso prévio;
        </div>
        <div>
          4.1.5. prestar Serviços Pagos, cujo custo, procedimento e calendário
          estão descritos nas secções relevantes do Sítio Web e do AM;
        </div>
        <div>
          4.1.6. enviar ofertas, convites e outros materiais a outros
          utilizadores registados e a terceiros em nome do utilizador registado;
        </div>
        <div>
          4.1.7. enviar aos Utilizadores Registados mensagens (incluindo através
          de Mensagens Pessoais, e-mails, mensagens SMS, etc.) que sejam
          notificações sobre alterações ou aditamentos ao Contrato, a introdução
          de novas funcionalidades ou o cancelamento de antigas funcionalidades
          do Sítio Web e do AM, novas mensagens recebidas, outros Conteúdos
          relacionados com o Utilizador Registado, etc., contendo informações
          publicitárias sobre as funcionalidades do Sítio Web e do AM, incluindo
          os Serviços Pagos.
        </div>
        <div>
          4.1.8. impor restrições adicionais à utilização do Sítio e do AM, e
          alterar essas restrições em qualquer altura;
        </div>
        <div>
          4.1.9. Tomar outras medidas para melhorar a qualidade e a facilidade
          de utilização do Sítio e da AM pelos Utilizadores.
        </div>
        <div>4.2. A administração compromete-se a:</div>
        <div>
          4.2.1. respeitar o sigilo da correspondência trocada pelos
          utilizadores registados através de mensagens privadas;
        </div>
        <div>
          4.2.2. não transmitir a outros utilizadores ou a terceiros informações
          a que o utilizador registado tenha tido acesso;
        </div>
        <div>
          4.2.3. envidar esforços comercialmente razoáveis para garantir o
          funcionamento do Sítio e do AM 24 horas por dia, mas a Administração
          não garante a ausência de interrupções devido a falhas técnicas,
          manutenção preventiva, bem como não garante a funcionalidade total ou
          parcial de elementos individuais do Sítio e do AM. A Administração não
          garante que o Sítio Web e o AM ou qualquer um dos seus elementos
          funcionem em qualquer altura específica no futuro ou que não deixem de
          funcionar.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>5. Direitos e obrigações do utilizador</b>
        </div>
        <div>5.1. O utilizador tem o direito:</div>
        <div>
          5.1.1. ler as informações publicadas no Site, utilizar os serviços do
          Site;
        </div>
        <div>
          5.1.2. enviar à Administração ou aos moderadores as suas propostas
          para corrigir erros e imprecisões detectados nas páginas do Sítio e do
          AM.
        </div>
        <div>5.1.3. enviar reclamações à Administração ou aos moderadores</div>
        <div>
          5.1.4. contactar a Administração para resolver eventuais litígios ou
          para obter ajuda na utilização do Site e do AM;
        </div>
        <div>
          5.1.5. utilizar todo o Conteúdo do Site e da forma prescrita pelo
          Acordo e outros documentos especiais da Administração, se o objectivo
          dessa utilização não for a obtenção de lucro
        </div>
        <div>
          5.1.6. registar-se no Sítio Web e no AM da forma determinada pelas
          disposições do Acordo e obter acesso a serviços adicionais do Sítio
          Web e do AM;
        </div>
        <div>5.2 O Utilizador compromete-se a:</div>
        <div>
          5.2.1. não realizar no Site e AM quaisquer actividades proibidas pelo
          Acordo;
        </div>
        <div>
          5.2.2. não reproduzir elementos do design ou da interface do
          utilizador do Sítio Web e do AM ao criar sítios de terceiros ou ao
          realizar qualquer actividade comercial dentro ou fora da Internet;
        </div>
        <div>
          5.2.3. não realizar outras acções, proibidas pela legislação da
          Federação Russa ou pelo Acordo, relacionadas com a utilização do Sítio
          Web e do AM.
        </div>
        <div>
          5.3 Ao utilizar o Website e o AM, o Utilizador está proibido de
        </div>
        <div>
          5.3.1. utilizar o Website e AM de qualquer forma que possa interferir
          com o normal funcionamento do Website e AM e dos seus serviços;
        </div>
        <div>
          5.3.2. carregar, armazenar, publicar, distribuir e fornecer acesso ou
          de outra forma utilizar vírus, cavalos de Tróia e outro software
          malicioso;
        </div>
        <div>
          5.3.3. carregar, publicar e transferir de outra forma os seguintes
          Conteúdos ou ligações de hipertexto para sítios Web que contenham
          esses Conteúdos:
        </div>
        <div>
          5.3.3.1. violar as disposições da legislação actual da Federação
          Russa;
        </div>
        <div>
          5.3.3.2. ofender a honra e a dignidade de outros Utilizadores e de
          terceiros;
        </div>
        <div>5.3.3.3. de carácter vulgar, obsceno e pornográfico;</div>
        <div>5.3.3.4. de carácter oficial ou não público;</div>
        <div>
          5.3.3.5. que violem os direitos exclusivos da Administração, de outros
          Utilizadores e de terceiros;
        </div>
        <div>
          5.3.3.6. conter dados pessoais de terceiros sem o seu consentimento
          para a publicação desses dados;
        </div>
        <div>
          5.3.3.7. que tenham por objectivo perturbar, destruir ou limitar a
          funcionalidade de qualquer software, hardware ou equipamento de
          telecomunicações;
        </div>
        <div>
          5.3.3.8. de natureza publicitária, bem como correspondência, spam,
          "cartas em cadeia", convites para participar em esquemas de pirâmide
          ou imposição de serviços de outras formas;
        </div>
        <div>
          5.3.3.9. contenha informações ou instruções para a prática de
          actividades ilegais ou descreva ou promova actividades criminosas, bem
          como instruções ou orientações para a prática de actividades
          criminosas;
        </div>
        <div>5.3.3.10. promova a crueldade contra os animais;</div>
        <div>
          5.3.3.11. Promova danos físicos ou lesões a qualquer entidade
          governamental, pessoa ou entidade, incluindo, mas não se limitando a,
          instruções para o fabrico de engenhos explosivos, explosivos, misturas
          incendiárias e outras armas e meios de destruição;
        </div>
        <div>
          5.3.3.12. Que contenham informações ameaçadoras, difamatórias ou
          desacreditadoras;
        </div>
        <div>5.3.3.13. seja de carácter fraudulento;</div>
        <div>
          5.3.3.14. propaganda de ódio ou inimizade racial, religiosa, étnica ou
          qualquer outra informação que viole os direitos do homem e do cidadão
          protegidos por lei; e carregamento de Conteúdos que violem direitos de
          propriedade e/ou pessoais não patrimoniais protegidos por lei e
          interesses legítimos de terceiros, incluindo direitos exclusivos de
          titulares de direitos e outros terceiros sobre os resultados da
          actividade intelectual;
        </div>
        <div>
          5.3.4. assediar, intimidar, abusar, perseguir ou de qualquer outra
          forma assediar maliciosamente qualquer Utilizador do Website e do AM;
        </div>
        <div>
          5.3.5. realizar acções destinadas a desestabilizar o funcionamento do
          Website e do AM, tentar aceder sem autorização à gestão do Website e
          do IG ou às suas secções fechadas (secções cujo acesso só é permitido
          pela Administração), bem como realizar quaisquer outras acções
          semelhantes;
        </div>
        <div>
          5.3.6. recolher, armazenar ou processar dados pessoais dos
          utilizadores registados para fins comerciais. Em especial, recolher
          endereços de correio electrónico ou outras informações de contacto dos
          utilizadores registados por meios automatizados ou outros, incluindo
          para efeitos de envio não autorizado de correio electrónico (spamming)
          ou outras informações não solicitadas;
        </div>
        <div>
          5.3.7. utilizar scripts (programas) automatizados para recolher
          informações e/ou interacção com o sítio Web e o AM e respectivos
          serviços;
        </div>
        <div>
          5.3.8. solicitar palavras-passe e outras informações de identificação
          dos Utilizadores Registados para utilização não autorizada, bem como
          para fins comerciais ou egoístas;
        </div>
        <div>
          5.3.9. tentar aceder à Conta de outro Utilizador de qualquer forma,
          incluindo através de pirataria informática, contra a vontade do
          Utilizador Registado a quem pertence;
        </div>
        <div>5.3.10. registar mais do que uma conta por utilizador;</div>
        <div>
          5.3.11. publicar dados pessoais de outros Utilizadores e de terceiros
          no Sítio Web e no AM ou transmitir através de mensagens pessoais, se o
          Utilizador não tiver obtido o seu consentimento para o tratamento de
          dados pessoais e para a publicação das referidas informações em fontes
          acessíveis ao público, em conformidade com o procedimento estabelecido
          por lei;
        </div>
        <div>
          5.3.12. registar uma Conta para utilização de um grupo de pessoas ou
          de uma organização;
        </div>
        <div>
          5.3.13. publicar mensagens de texto, imagens gráficas e outros
          materiais, que contenham anúncios, no Sítio e no AM em acesso público
          sem o consentimento prévio da Administração, transmitir através das
          mensagens pessoais sem o consentimento prévio do Utilizador Registado
        </div>
        <div>
          5.3.14. utilizar o Sítio e o AM para quaisquer fins comerciais sem
          autorização prévia da Administração;
        </div>
        <div>
          5.3.15. publicar qualquer informação que, na opinião da Administração,
          seja indesejável, não cumpra os objectivos do Site e do AM, infrinja
          os interesses dos Utilizadores ou que, por outras razões, seja
          indesejável para publicação no Site e no AM.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>6. Direitos e obrigações do utilizador registado</b>
        </div>
        <div>
          6.1 O utilizador registado tem direito, para além dos direitos
          estipulados na cláusula 5.1. Acordo:
        </div>
        <div>
          6.1.1. ajustar as configurações da Conta e do Perfil, alterar o
          endereço de e-mail, o número de telefone e a senha de acesso à Conta;
        </div>
        <div>
          6.1.2. publicar informações sobre si na Conta/Perfil, adicionar
          fotografias, ficheiros áudio e vídeo;
        </div>
        <div>
          6.1.3. publicar qualquer Conteúdo que não seja inconsistente com as
          disposições da legislação actual da Federação Russa e do Acordo;
        </div>
        <div>
          6.1.4. enviar mensagens e responder a mensagens de outros utilizadores
          nas secções de Conversa e Diálogo das secções correspondentes do AM e
          em todas as páginas do Sítio Web, sempre que fornecido pela interface;
        </div>
        <div>
          6.1.5. acrescentar as informações necessárias na secção
          "Perfil/árvore" do utilizador registado. O utilizador registado pode
          definir a quem a secção "Perfil/árvore" será visível: visível para
          todos os contactos, nas secções "Diálogo" e "Conversa", visível apenas
          para o utilizador registado;
        </div>
        <div>
          6.1.7. receber notificações sobre os eventos seleccionados nas
          definições da Conta no Sítio Web e no AM e, em caso de consentimento
          para receber tais cartas, por correio electrónico.
        </div>
        <div>
          6.1.8. criar, através da sua Conta/Perfil, e publicar dados pessoais
          de outros particulares, desde que o particular/representante legal do
          particular/herdeiros legais do particular tenham dado o seu
          consentimento prévio para o tratamento dos seus dados pessoais no
          Sítio Web e no AM e que os dados pessoais publicados sejam
          considerados públicos, ou desde que, no momento da publicação, os
          dados pessoais estejam disponíveis publicamente, ou seja, os dados
          pessoais sejam disponibilizados publicamente pelo titular dos dados
          pessoais ou sejam obtidos a partir de um sítio público. O perfil
          criado, dependendo das definições de privacidade do AM, pode ser
          visível através de uma hiperligação para os contactos do utilizador e
          para os utilizadores registados do AM ou apenas para o utilizador
          registado que o criou;
        </div>
        <div>
          6.1.9. alterar as fotos e outras informações publicadas pelo
          Utilizador Registado nos Perfis Pessoais por ele criados;
        </div>
        <div>
          6.1.10. adicionar informações sobre indivíduos, de acordo com a
          cláusula 6.1.8 do Acordo ou indicando um Perfil previamente criado;
        </div>
        <div>
          6.1.11. enviar e receber mensagens pessoais de outros Utilizadores
          Registados;
        </div>
        <div>
          6.1.12. eliminar a sua Conta contactando a Administração ou através de
          outros meios disponibilizados pelo Sítio Web e pelo AM.
        </div>
        <div>
          6.2 O utilizador registado deverá, para além de cumprir as obrigações
          estipuladas na cláusula 5.2. do Acordo:
        </div>
        <div>
          6.2.1. fornecer no momento do registo informações precisas, actuais e
          completas, que lhe podem ser solicitadas pela Administração através da
          utilização dos formulários de registo do Site e AM, e após o registo a
          pedido da Administração no âmbito da execução do presente Acordo para
          confirmar as suas credenciais, incluindo nome, apelido, patronímico,
          outros dados;
        </div>
        <div>
          6.2.2. tomar as medidas necessárias para garantir a confidencialidade
          do login e da password utilizados para o acesso à Conta;
        </div>
        <div>
          6.2.3. garantir que a palavra-passe não é guardada no browser
          (incluindo quando se utiliza a tecnologia de cookies) se outras
          pessoas puderem utilizar o computador;
        </div>
        <div>
          6.2.4. ao criar e editar Perfis de outras pessoas singulares através
          da sua Conta, publicar informações exactas e actualizadas no Sítio
          Web;
        </div>
        <div>
          6.2.5. informar a Administração sobre todos os casos de acções
          relacionadas com o Utilizador Registado que possam ser consideradas
          insultuosas, degradantes, desacreditadoras, etc;
        </div>
        <div>
          6.2.6. informar a Administração sobre o acesso não autorizado à conta
          e/ou a utilização da palavra-passe e do início de sessão do utilizador
          registado;
        </div>
        <div>
          6.2.7. não publicar no Perfil e noutras secções do sítio Web e do AM
          informações que possam violar os direitos e interesses de outras
          pessoas;
        </div>
        <div>
          6.3 O Utilizador Registado está proibido, para além das proibições
          enumeradas na cláusula 5.3. do Acordo:
        </div>
        <div>
          6.3.1. reproduzir, copiar ou duplicar a Conta, permitir o acesso de
          terceiros à sua Conta, ou alienar os direitos sobre a Conta;
        </div>
        <div>
          6.3.2. falsificar dados técnicos ou manipular de outra forma os dados
          com o objectivo de ocultar ou substituir a fonte das informações
          transferidas durante a utilização da Conta;
        </div>
        <div>
          6.3.3. ao registar a Conta ou ao introduzir subsequentemente
          informações falsas ou fictícias sobre si próprio, em particular, um
          nome e apelido falsos ou alterados;
        </div>
        <div>
          6.3.4. colocar imagens de outras pessoas ou personagens fictícias,
          imagens de animais, objectos, imagens abstractas, bem como quaisquer
          outras imagens gráficas, que não sejam imagens das pessoas
          mencionadas, no Sítio Web e no AM;
        </div>
        <div>
          6.3.5. enviar spam em mensagens pessoais, comentários, mensagens em
          fóruns de Perfis, etc., se os Utilizadores Registados que recebem
          essas informações não tiverem expressado o seu consentimento para
          receber essas informações.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>7. Responsabilidade das partes.</b>
        </div>
        <div>
          7.1 O Site e o AM são um meio para os Utilizadores transmitirem
          informações. A Administração não participa na formação do conteúdo da
          Conta/Perfil e no carregamento do Conteúdo pelo Utilizador, não
          controla as acções do Utilizador, não realiza a censura automática de
          informações nas secções abertas do Site e do AM, nas Mensagens
          Pessoais dos Utilizadores Registados e não é responsável por acções ou
          inacções do Utilizador, porque o sistema de informação do Site do AM e
          o seu software não contêm soluções técnicas para a administração das
          acções acima especificadas.
        </div>
        <div>
          7.2 A responsabilidade pelas informações publicadas pelo Utilizador no
          Site e no AM é do Utilizador que as forneceu.
        </div>
        <div>7.3. A Administração não é responsável</div>
        <div>
          7.3.1. pela execução e realização de transações entre os Utilizadores
          e entre os Utilizadores e terceiros com base em informações de
          natureza publicitária e não publicitária publicadas pela Administração
          no Site e no AM. As relações entre os Utilizadores, bem como entre o
          Utilizador e terceiros, são reguladas por contratos separados
          celebrados entre os Utilizadores e entre o Utilizador e terceiros;
        </div>
        <div>
          7.3.2. pela exactidão dos dados pessoais fornecidos pelos Utilizadores
          registados;
        </div>
        <div>
          7.3.3. por eventuais falhas e interrupções no funcionamento do Sítio
          Web e do AM e pela consequente perda de informações. A Administração
          não será responsável por quaisquer danos no computador do Utilizador,
          dispositivos móveis, qualquer outro hardware ou software causados por
          ou relacionados com a utilização de sites acessíveis através de
          hiperligações publicadas no Site e no AM, tanto por Utilizadores como
          por terceiros. O acesso a sites de terceiros, a instalação de software
          e o consumo de serviços de terceiros são por conta e risco do
          Utilizador. As disposições do Contrato não se aplicam à relação entre
          o Utilizador e terceiros;
        </div>
        <div>
          7.3.4. por danos causados ao Utilizador em resultado da interacção com
          a publicidade colocada no Sítio e no AM;
        </div>
        <div>
          7.3.5. pelas consequências da utilização da palavra-passe da Conta de
          Utilizador Registado por terceiros, bem como pelas acções por eles
          realizadas utilizando a Conta;
        </div>
        <div>
          7.3.6. por danos, incluindo a perda de dados, que possam ser causados
          ao Utilizador pela eliminação da Conta, do Conteúdo ou pela cessação
          do funcionamento do Sítio e do AM;
        </div>
        <div>
          7.3.7. por quaisquer danos, incluindo perdas reais e/ou lucros
          cessantes e/ou dados perdidos, danos à vida e à saúde, à honra, à
          dignidade ou à reputação comercial, que sejam causados pela utilização
          do Sítio e do AM, pelos conteúdos do Sítio e do AM ou por outros
          materiais a que os Utilizadores ou outras pessoas tenham obtido acesso
          através do Sítio e do AM, mesmo que a Administração tenha avisado ou
          aconselhado da possibilidade de tais danos.
        </div>
        <div>
          7.4 A Administração envida todos os esforços possíveis para excluir
          informações ofensivas, falsas ou ilegais do sítio Web e do AM.
        </div>
        <div>
          7.5 A Administração não garante que o software, os servidores e as
          redes informáticas utilizados pelo Sítio Web e pelo AM estejam isentos
          de bugs e malware. A Administração não será responsável se a
          utilização do sítio Web e do AM resultar em perda de dados ou danos no
          equipamento.
        </div>
        <div>
          7.6 O Utilizador Registado é responsável pelos actos ilícitos
          praticados com a utilização da sua Conta, bem como pela publicação dos
          Conteúdos utilizando a sua Conta no Sítio Web e no AM, no Perfil, nos
          Perfis de outros Utilizadores Registados, nas mensagens, nas secções
          "Conversa", "Diálogo" e "Chat-bot" e noutras secções do Sítio Web e do
          AM.
        </div>
        <div>
          7.7 A Administração tem o direito de suspender a Conta de um
          Utilizador Registado que seja legalmente incapaz se o Utilizador
          Registado não fornecer à Administração, no prazo especificado no
          Acordo, o consentimento previamente obtido do seu representante legal
          para o processamento de dados pessoais no Sítio Web e no AM e que os
          dados pessoais publicados no Perfil serão considerados públicos até
          que este Utilizador Registado cumpra a obrigação prevista na Secção
          6.2.6. do Acordo. 6.2.6. do Acordo.
        </div>
        <div>
          7.8 A Administração terá o direito de suspender o Perfil criado pelo
          Utilizador Registado através da sua Conta para outra pessoa singular,
          se o Utilizador Registado não fornecer à Administração, no prazo
          especificado no Acordo, o consentimento previamente obtido da pessoa
          singular/representante legal de uma pessoa singular inválida ou
          incapacitada/herdeiro de uma pessoa singular falecida, até que este
          Utilizador Registado cumpra a obrigação estipulada na cláusula 6.2.5.
          6.2.5. do Acordo.
        </div>
        <div>
          7.9. 7.9 O acesso do Utilizador Registado ao Sítio Web e ao AM, bem
          como a secções individuais do Sítio Web e do AM, pode ser restringido,
          suspenso ou cessado por um período indefinido em caso de violação das
          disposições do Acordo. O acesso pode ser restabelecido mediante pedido
          escrito do Utilizador, à discrição da Administração.
        </div>
        <div>
          7.10. A Administração não será obrigada a fornecer ao Utilizador
          quaisquer provas, documentos ou quaisquer outras evidências de
          violação dos termos do presente Acordo por parte do Utilizador que
          tenham resultado na recusa do acesso do Utilizador ao Sítio Web e ao
          AM ou às suas funções individuais, ou na cessação e/ou limitação desse
          acesso.
        </div>
        <div>
          7.11. No caso de o Utilizador violar as proibições estabelecidas pelo
          Acordo e outros documentos do Website e da Administração do AM, o
          Utilizador compromete-se a compensar o Website e a Administração do AM
          por todas as perdas causadas por tais violações.
        </div>
        <div>
          7.12. A Administração não indemniza o Utilizador pelas despesas
          relacionadas com a aquisição de direitos de utilização dos Serviços
          Pagos em caso de suspensão ou cessação do acesso do Utilizador ao Site
          ou ao AM, ou de suspensão ou cessação do Contrato por qualquer motivo.
        </div>
        <div>
          7.13. A Administração não modera nem censura a informação publicada
          pelos Utilizadores, e toma medidas para proteger os direitos e
          interesses dos indivíduos e assegurar o cumprimento da legislação da
          Federação Russa e das disposições do Acordo apenas após o pedido da
          pessoa em causa à Administração. O Utilizador ou um terceiro que
          considere que os seus direitos foram violados pelas acções da
          Administração, de outros Utilizadores ou de terceiros em relação com a
          colocação no Sítio ou com os Conteúdos do AM, pode enviar uma queixa à
          Administração para o endereço de correio electrónico indicado no
          Acordo para tratar de recursos, ou através da interface do Sítio e do
          AM. A reclamação deve ser apresentada num prazo razoável, ser
          fundamentada e justificada. A Administração analisará a reclamação
          recebida no prazo de 30 (trinta) dias após a sua recepção. Se a
          Administração considerar que os direitos do Utilizador ou de um
          terceiro foram violados, o acesso ao Conteúdo especificado na
          reclamação será suspenso e/ou esse Conteúdo será excluído do livre
          acesso e/ou eliminado. Se os direitos do Utilizador ou de terceiros
          tiverem sido violados, a Administração terá o direito de solicitar ao
          queixoso documentos que confirmem a violação dos direitos do
          Utilizador ou de terceiros. Na ausência de provas de uma violação dos
          direitos do Utilizador ou de terceiros, a Administração não tomará
          qualquer medida.
        </div>
        <div>
          7.14. No caso de reclamações de terceiros em relação à violação dos
          termos deste Acordo pelo Utilizador em termos de publicação de
          Conteúdo de terceiros, a Administração terá o direito de transferir,
          dentro do quadro permitido pela lei, as informações de contacto do
          Utilizador disponíveis para a Administração para os queixosos, a fim
          de resolver os desacordos.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>8. Direitos sobre o conteúdo do sítio Web e a AM</b>
        </div>
        <div>
          8.1. Todos os objectos publicados no Website e no AM pela
          Administração, incluindo literatura e arte, software, bases de dados,
          nomes de marcas, marcas comerciais, marcas de serviço e outros
          objectos são o resultado da actividade intelectual e meios semelhantes
          de individualização da Administração ou de outras pessoas de acordo
          com a informação especificada.
        </div>
        <div>
          8.2. Ao colocar o seu Conteúdo no AM, o Utilizador concede à
          Administração uma licença não-exclusiva para a duração dos seus
          direitos de propriedade intelectual em todo o mundo para utilizar o
          Conteúdo de qualquer forma, incluindo visualização, reprodução
          (incluindo cópia), processamento (incluindo impressão de cópias) e
          outros direitos, se o objectivo de tal utilização não for a obtenção
          de lucro ou rendimento;
        </div>
        <div>
          8.3. Se o Utilizador eliminar os seus Conteúdos do AM, os direitos
          mencionados na cláusula 8.2. do Acordo serão automaticamente
          revogados, mas a Administração tem o direito de manter cópias de
          arquivo do Conteúdo por um período indefinido.
        </div>
        <div>
          8.4. O Utilizador não pode carregar (descarregar ou disponibilizar de
          outra forma) informações de outros sites, bases de dados ou outros
          objectos de direitos exclusivos na ausência do consentimento explícito
          do titular do direito para tais actividades.
        </div>
        <div>
          8.5. O Acordo não prevê a cessão de quaisquer direitos exclusivos ou a
          concessão de uma licença exclusiva para quaisquer componentes do
          Website e AM da Administração para o Utilizador.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>
            9. Regras de utilização dos materiais publicados no Sítio Web e no
            AM
          </b>
        </div>
        <div>
          9.1. É proibida qualquer utilização de materiais do Sítio e do AM sem
          o consentimento escrito da Administração para essa utilização.
        </div>
        <div>
          9.2. Se existir uma autorização por escrito da Administração, a
          utilização dos materiais é permitida nas seguintes condições:
        </div>
        <div>
          9.2.1. referência à fonte do material - o Site e o AM, e ao colocar
          materiais na Internet uma hiperligação para o endereço do Site e do AM
          com os materiais colocados;
        </div>
        <div>
          9.2.2. ao reproduzir materiais, não é permitido retrabalhar o texto
          original. A redução ou reorganização de partes do material é
          permitida, mas apenas na medida em que não distorça o significado do
          material;
        </div>
        <div>
          9.2.3. quando os materiais são utilizados em resumos de imprensa, não
          é permitido retrabalhar os materiais de forma a distorcer o seu
          significado;
        </div>
        <div>
          9.2.4. a responsabilidade pela distorção do significado dos materiais
          resultante da sua reprodução incorrecta é da pessoa que os utiliza;
        </div>
        <div>
          9.2.5. se a legenda de qualquer fotografia, ilustração, gravação de
          texto ou outra publicação do conteúdo indicar o nome do autor ou do
          detentor dos direitos de autor, a reprodução deve ser-lhe directamente
          dirigida.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>10. Segurança da informação do site e do AM</b>
        </div>
        <div>
          10.1. Ao utilizar o site, o utilizador compromete-se a não violar ou
          tentar violar a segurança das informações do site e do AM, o que
          inclui:
        </div>
        <div>
          10.1.1. aceder a informações que não se destinem a ser utilizadas pelo
          utilizador ou iniciar sessão com um nome de utilizador que não
          pertença ao utilizador registado;
        </div>
        <div>
          10.1.2. tentativas de testar a vulnerabilidade dos sistemas de
          segurança do Site e do AM, violação do procedimento de registo e
          autorização sem a autorização da Administração;
        </div>
        <div>
          10.1.3. tentativas de impedir que outros Utilizadores utilizem o Site
          e o AM, o que inclui a distribuição de malware, a eliminação, a
          corrupção de dados, o envio constante de informações repetidas, o
          envio de mensagens de correio electrónico através do Site e do
          servidor do AM, o envio simultâneo de várias mensagens de correio
          electrónico e/ou pedidos ao Site e ao servidor do AM com o objectivo
          de desactivar intencionalmente o Site e o servidor do AM, etc., fora
          da utilização normal e prevista do Site e do AM, o que pode provocar,
          intencionalmente ou não, o mau funcionamento do Site e do AM;
        </div>
        <div>
          10.1.4. enviar informações aos Utilizadores, para as quais estes não
          tenham dado o seu consentimento, bem como enviar spam e publicidade
          sem a autorização da Administração;
        </div>
        <div>
          10.1.5. imitar e/ou forjar qualquer cabeçalho de pacote TCP/IP ou
          qualquer parte do cabeçalho em qualquer correio electrónico ou
          material publicado no Sítio e no AM;
        </div>
        <div>
          10.1.6. utilizar ou tentar utilizar qualquer software ou procedimento
          para navegar ou pesquisar no Sítio e no AM que não sejam os browsers
          publicamente disponíveis (Microsoft Edge, Google Chrome, Opera,
          Mozilla Firefox, Yandex Browser, Safari e similares).
        </div>
        <div>
          10.2. As violações da segurança do sistema ou da rede informática
          darão origem a responsabilidade civil e criminal. A Administração
          investigará todos os casos de possíveis violações da segurança por
          parte dos Utilizadores, em cooperação com as autoridades competentes,
          para pôr termo a essas actividades maliciosas.
        </div>
        <div>
          10.3. A Administração não é responsável pela eventual utilização
          indevida de informações do Sítio e do IG por parte dos Utilizadores
          registados ou de outras pessoas, que tenha ocorrido sem notificação da
          Administração, com ou sem violação da segurança das informações do
          Sítio e do MA.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>11. Publicidade</b>
        </div>
        <div>
          11.1. O Utilizador compreende e aceita que todos ou parte dos Serviços
          do Website e do AM podem ser acompanhados por anúncios. Ao utilizar o
          Sítio Web e o AM, o Utilizador reconhece o direito da Administração de
          colocar tais anúncios sem aviso prévio e sem qualquer compensação para
          os Utilizadores. A natureza e a quantidade de publicidade apresentada
          no Sítio Web e no AM em geral são determinadas e alteradas à discrição
          da Administração.
        </div>
        <div>
          11.2. A Administração não é uma parte entre o Utilizador e o
          Anunciante e não é responsável por violações de obrigações decorrentes
          da sua relação.
        </div>
      </div>,
      <div style={{ marginBottom: '10px' }}>
        <div>
          <b>12. Disposições finais</b>
        </div>
        <div>
          12.1. O presente Acordo é celebrado entre o Utilizador e a
          Administração relativamente à ordem de utilização do Sítio e do AM e
          dos seus serviços, é exaustivo e substitui todos os acordos anteriores
          entre o Utilizador e a Administração.
        </div>
        <div>
          12.2. Todos os litígios das Partes ao abrigo do presente Acordo serão
          resolvidos por correspondência e negociações, utilizando o
          procedimento obrigatório de pré-julgamento (reclamação). Se as Partes
          não conseguirem chegar a um acordo através de negociações no prazo de
          trinta (30) dias de calendário a partir da data de recepção pela outra
          Parte de uma reclamação por escrito, o litígio deve ser remetido por
          qualquer parte interessada para o tribunal de jurisdição geral na
          localização do Administrador (excluindo a jurisdição de quaisquer
          outros tribunais).
        </div>
        <div>
          12.3. O Acordo será regido pelas leis da Federação Russa, excepto se
          indicado em contrário no texto do Acordo. As questões não reguladas
          pelo Acordo devem ser resolvidas de acordo com as leis da Federação
          Russa.
        </div>
        <div>
          12.4. Caso o Utilizador esteja proibido pelas leis do seu país de
          utilizar a Internet ou sites semelhantes ao Site e ao AM, ou caso
          existam outras restrições legais, incluindo restrições quanto à idade
          de acesso a esse software, o Utilizador não tem o direito de utilizar
          o Site e o AM no território desse país. Nesse caso, o Utilizador é o
          único responsável pela utilização do Site e do AM no território do seu
          país, em violação da legislação local.
        </div>
        <div>
          12.5. Se uma ou mais disposições do Acordo forem inválidas, o Acordo
          aplicar-se-á na medida em que não contradiga a legislação da Federação
          Russa.
        </div>
      </div>,
    ],
  },
  noMatch: {
    title: 'Ops! Algo deu errado…',
    description:
      'A página que você está solicitando não existe. Pode estar desatualizado, removido ou o endereço errado foi inserido na barra de endereço.',
    goMain: 'Voltar para a página principal',
  },
};
